import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAdminSidebar, LazyAppScreens, LazyAppStoreButton, LazyCheersButton, LazyConnectButton, LazyCookie, LazyDownloadAppStore, LazyDownloadPlayStore, LazyFAQItem, LazyFeatureAchievements, LazyFeatureAnalyse, LazyFeatureBuddy, LazyFeatureChallenge, LazyFeatureCraving, LazyFeatureHealth, LazyFeatureMilestones, LazyFeatureSavings, LazyFeatureSuperPower, LazyFollowButton, LazyFooter, LazyHeader, LazyHeaderAuth, LazyIconApple, LazyIconFacebook, LazyIconGoogle, LazyIconInstagram, LazyIconLinkedin, LazyIconTwitter, LazyIconVerify, LazyInstructionStep, LazyIntersection, LazyNavigation, LazyNewsletterForm, LazyPlayStoreButton, LazyPostCategories, LazyPostItem, LazyPostItemFeatured, LazyPrivacySection, LazyQuitGauge, LazyShare, LazySmoxyLogo, LazySmoxyLogoType, LazyStoreRating, LazySubscribeForm, LazyTeaserSignUp, LazyTermsItem, LazyAuthor, LazyConclusion, LazyFeature, LazyGrid, LazyGrid2, LazyListTile, LazyPage, LazyPost, LazyReferenceItem, LazySectionIntro, LazySectionTitleBody, LazyStepItem, LazySteps, LazyTeaser, LazyWrapList, LazyCategory, LazyCookieClientOnlyPrerender, LazyCookieControl, LazyCookieIframe } from '#components'
const lazyGlobalComponents = [
  ["AdminSidebar", LazyAdminSidebar],
["AppScreens", LazyAppScreens],
["AppStoreButton", LazyAppStoreButton],
["CheersButton", LazyCheersButton],
["ConnectButton", LazyConnectButton],
["Cookie", LazyCookie],
["DownloadAppStore", LazyDownloadAppStore],
["DownloadPlayStore", LazyDownloadPlayStore],
["FAQItem", LazyFAQItem],
["FeatureAchievements", LazyFeatureAchievements],
["FeatureAnalyse", LazyFeatureAnalyse],
["FeatureBuddy", LazyFeatureBuddy],
["FeatureChallenge", LazyFeatureChallenge],
["FeatureCraving", LazyFeatureCraving],
["FeatureHealth", LazyFeatureHealth],
["FeatureMilestones", LazyFeatureMilestones],
["FeatureSavings", LazyFeatureSavings],
["FeatureSuperPower", LazyFeatureSuperPower],
["FollowButton", LazyFollowButton],
["Footer", LazyFooter],
["Header", LazyHeader],
["HeaderAuth", LazyHeaderAuth],
["IconApple", LazyIconApple],
["IconFacebook", LazyIconFacebook],
["IconGoogle", LazyIconGoogle],
["IconInstagram", LazyIconInstagram],
["IconLinkedin", LazyIconLinkedin],
["IconTwitter", LazyIconTwitter],
["IconVerify", LazyIconVerify],
["InstructionStep", LazyInstructionStep],
["Intersection", LazyIntersection],
["Navigation", LazyNavigation],
["NewsletterForm", LazyNewsletterForm],
["PlayStoreButton", LazyPlayStoreButton],
["PostCategories", LazyPostCategories],
["PostItem", LazyPostItem],
["PostItemFeatured", LazyPostItemFeatured],
["PrivacySection", LazyPrivacySection],
["QuitGauge", LazyQuitGauge],
["Share", LazyShare],
["SmoxyLogo", LazySmoxyLogo],
["SmoxyLogoType", LazySmoxyLogoType],
["StoreRating", LazyStoreRating],
["SubscribeForm", LazySubscribeForm],
["TeaserSignUp", LazyTeaserSignUp],
["TermsItem", LazyTermsItem],
["Author", LazyAuthor],
["Conclusion", LazyConclusion],
["Feature", LazyFeature],
["Grid", LazyGrid],
["Grid2", LazyGrid2],
["ListTile", LazyListTile],
["Page", LazyPage],
["Post", LazyPost],
["ReferenceItem", LazyReferenceItem],
["SectionIntro", LazySectionIntro],
["SectionTitleBody", LazySectionTitleBody],
["StepItem", LazyStepItem],
["Steps", LazySteps],
["Teaser", LazyTeaser],
["WrapList", LazyWrapList],
["Category", LazyCategory],
["CookieClientOnlyPrerender", LazyCookieClientOnlyPrerender],
["CookieControl", LazyCookieControl],
["CookieIframe", LazyCookieIframe],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
